// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__QMDwQ"};